module.exports = __webpack_public_path__ + "static/img/icon-online.df383628.svg";